/*
 * @Author: your name
 * @Date: 2020-11-30 14:06:14
 * @LastEditTime: 2021-03-22 11:43:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Statistic.js
 */

import * as storage from "./Storage";
import * as browser from "./Device/Browser";
import * as info from "./Device/Info";
import * as axios from "axios/dist/axios";
import * as dateUtil from "../../utils/dateUtil";
import { handleLocalStorage } from "@/utils/handleLocalStorage.js";

function getLongTimeUuid() {
  return storage.getCookie("playUid");
}

function setLongTimeUuid() {
  const a = browser.getUuid();
  storage.setCookie("playUid", a, 219e3);
  return a;
}

function getShortTimeUuid() {
  return storage.getSessionStorageItem("playPid");
}

function setShortTimeUuid() {
  const a = browser.getUuid();
  storage.setSessionStorageItem("playPid", a);
  return a;
}

function getCurrSeconds() {
  const d = new Date();
  // d.setHours(d.getHours(), d.getMinutes() - d.getTimezoneOffset())
  d.setHours(d.getHours(), d.getMinutes());
  return dateUtil.dateTimeFormat(d);
  // return d.toISOString()
}

/**
 * 记录开始访问信息
 * @param {string} modelId 模型ID
 */
export function startVisit(modelId) {
  const userInfo = handleLocalStorage.getSomeItem("userInfo");
  // let uid = getLongTimeUuid()
  let uid;
  if (userInfo) {
    uid = userInfo.userId;
  } else {
    uid = -1;
  }

  const vid = setShortTimeUuid();

  const deviceInfo = info.deviceInfo();

  storage.setSessionStorageItem("modelId", modelId);
  const ts = getCurrSeconds();
  const data = {
    userId: uid,
    pageId: vid,
    modelId: modelId,

    // createTime: ts,
    // visitTime: ts,

    device: deviceInfo.deviceType,
    os: deviceInfo.OS,
    version: deviceInfo.OSVersion,
    ua: deviceInfo.userAgent,
    appVersion: deviceInfo.appVersion,
    height: deviceInfo.screenHeight,
    width: deviceInfo.screenWidth,
    lan: deviceInfo.language,
    connection: deviceInfo.netWork,
    orientation: deviceInfo.orientation
  };

  axios({
    baseURL: "/docking",
    url: "/api/recordVisit/recordVisit",
    method: "POST",
    data: data
  });
}

/**
 * 心跳维持
 * @param {number} pointId 点位id
 */
export function heartbeat(pointId) {
  const userInfo = handleLocalStorage.getSomeItem("userInfo");
  // let uid = getLongTimeUuid()
  let uid;
  if (userInfo) {
    uid = userInfo.userId;
  } else {
    uid = -1;
  }
  const data = {
    userId: uid,
    pageId: getShortTimeUuid(),
    modelId: storage.getSessionStorageItem("modelId"),

    currentTime: getCurrSeconds(),

    pointId: pointId
  };
  axios({
    baseURL: "/docking",
    url: "/api/logVisit/heartbeat",
    method: "POST",
    data: data
  });
}

/**
 * 记录操作
 * @param {number} interactType 交互类型
 * @param {number} pointId 点位id
 */
export function markInteract(interactType) {
  const data = {
    userId: getLongTimeUuid(),
    pageId: getShortTimeUuid(),
    modelId: storage.getSessionStorageItem("modelId"),

    currentTime: getCurrSeconds(),

    statisticType: 2,
    interactionType: interactType
  };
  axios({
    baseURL: "/docking",
    url: "/api/logOperation/record",
    method: "POST",
    data: data
  });
}

export function markPoint(pointId) {
  const data = {
    userId: getLongTimeUuid(),
    pageId: getShortTimeUuid(),
    modelId: storage.getSessionStorageItem("modelId"),

    currentTime: getCurrSeconds(),

    statisticType: 3,
    interactionType: 1,
    pointId: pointId
  };
  axios({
    baseURL: "/docking",
    url: "/api/logOperation/record",
    method: "POST",
    data: data
  });
}

export function buryingPoint(type) {
  let data = {
    terminal: deviceJudge(),
    page_title: document.title,
    number: 1,
    field_type: [type]
  };
  axios({
    baseURL: "/docking",
    url: "/api/dataCollect/create",
    method: "POST",
    data: data
  });
}
// 设备类型
export function deviceJudge() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return "ios";
  } else if (/(Android)/i.test(navigator.userAgent)) {
    return "android";
  } else if (/(Mac)/i.test(navigator.userAgent)) {
    return "Mac";
  } else if (/(Window)/i.test(navigator.userAgent)) {
    return "Window";
  } else {
    return "unkown";
  }
}

export const InteractType = {
  To3D: 1,
  ToPanel: 2,
  Play: 3,
  Vr: 4,
  View: 5,
  Map: 6,
  Phone: 7,
  Music: 8,
  Measure: 9
};
